import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { Controller, useForm, FormProvider } from "react-hook-form"
import Screen from "src/shared/components/layout/screen/Screen"
import { InputTel, InputText, TextBox } from "src/shared/components/forms"
import Dropdown from "src/shared/components/forms/selelct-dropdown/Dropdown"
import ModalAcceptReservation from "./sections/ModalAcceptReservation.section"
import { ModalConfirm } from "src/shared/components/layout"
import ModalMixto from "src/shared/sections/payment/mixto/ModalMixto"
import { PAYMENT_METHODS, PAYMENT_TYPES } from "src/constants/payments"
import Icon from "src/shared/icons"
import { PaymentFields, PaymentSelect, AbonarEasyRewardsFields } from "./sections/Fields"
import { getParams } from "../../shared/helpers"
import { useFormatDate } from "src/shared/hooks/useFormatDate"
import SnackBar from "src/shared/components/data-display/SnackBar/SnackBar"
import useMiniSnackbar from "src/shared/hooks/useMiniSnackbar"
import { payments, defaultValues, inputIconStyle, amountPayments, amountPaymentsEdit } from "../../shared/constants"
import { FormValues, ModalStatus } from "./reserva-formulario-final.types"
import "./ReservaFormularioFinal.css"
import {
    CreateReservaInput,
    UpdateReservaInput,
    DetallePagoPartialInfoObject,
    OrigenRservas,
    TiposPagos,
    useCrear_ReservaMutation,
    useActualizar_ReservaMutation,
    useGetExperienciasQuery,
    useGetIncidenciaByFiltersLazyQuery,
    EstadosReservas,
    TiposAlojamientos,
} from "src/gql/schema"
import { quitarParentesisYEspacios } from "src/shared/hooks/quitarParentecisySpace"
import { useProfile } from "src/shared/hooks/useProfile"
import Decimal from "decimal.js"
import { sum, minus } from "src/shared/helpers/calculator"
import { useDate } from "src/shared/hooks/useDate"
import Resumen from "./sections/Resumen/Resumen"
import useEscapeKey from "src/shared/hooks/useEscapeKey"
import useLoadingState from "src/shared/hooks/useLoadingState"
import LoaderComponent from "src/shared/components/layout/loader/Loader"
import { addDays } from "src/shared/helpers/addDays"
import { LovePoint } from "src/pages/easyrewards/components/InputAbonarEasyRewards/InputAbonarEasyRewards.types"
import useValidSameDayRent from "src/pages/venta-habitacion/hooks/useValidSameDayRent"
import useAuth, { RoleNames } from "src/shared/hooks/useAuth"
import AuthRequiredModal from "src/pages/inventario/modals/Auth/AuthRequiredModal/AuthRequiredModal"
import { useMotorTarifas } from "src/shared/hooks/useMotorTarifas"
import ModalDescuentos, { useStateDescuentos } from "src/shared/modals/ModalDescuentos/ModalDescuentos"
import { useOpcionesDescuentos } from "src/shared/modals/ModalDescuentos/hooks/useOpcionesDescuentos"
import CancelReservaModal from "../../shared/components/CancelReservaModal/CancelReservaModal"

function ReservaFormularioFinal(): JSX.Element {
    const location = useLocation()

    const methods = useForm<FormValues>({
        defaultValues,
    })

    const costos = methods.watch("costs")
    const clientName = methods.watch("name")
    const tipoPago = methods.watch("payment")
    const metodoActual = methods.watch("method")

    const { control, handleSubmit, setValue } = methods
    const [createReservaMutation] = useCrear_ReservaMutation()
    const [updateReservaMutation] = useActualizar_ReservaMutation()
    const [isModalConfirmOpen, setisModalConfirmOpen] = useState(false)
    const [isCancelModalOpen, setIsCancelModalOpen] = useState(false)
    const [isErrorCreateR, setIsErrorCreateR] = useState(false)
    const [isErrorUpdateR, setIsErrorUpdateR] = useState(false)

    const [codigoRes, setCodigoRes] = useState<string>("")
    const [reservaFolio, setReservaFolio] = useState<string>("")
    const [visibleToast, setVisibleToast] = useState<boolean>(false)
    const [stateMixto, setStateMixto] = useState<ModalStatus>({ visible: false, edited: false })
    const { hotel_id, usuario_id, zona_horaria } = useProfile()

    const { isLoading, isLoadingDelayed, toggleIsLoading, tryStartLoading } = useLoadingState()

    const [lovePointsAmount, setLovePointsAmount] = useState<LovePoint | null>(null)

    const { descuento, setDescuento } = useStateDescuentos()

    const isDescuentoDisabled = metodoActual === PAYMENT_TYPES.Cortesia || metodoActual === PAYMENT_TYPES.ConsumoInterno || tipoPago !== PAYMENT_TYPES.total
    
    const [getIncidenciasHuesped, { loading, data: incidenciasHuesped }] = useGetIncidenciaByFiltersLazyQuery()

    const navigate = useNavigate()
    const { formatCustomDate, getStartOfHotelDayISO, serverDate } = useFormatDate()
    const { diffDays, setHHMMSS, localDateToUTCString } = useDate(zona_horaria, serverDate)

    const { showMiniSnackbar } = useMiniSnackbar()

    const {
        cantidadPersonasExtra,
        fechaReserva,
        horaCheckIn,
        horaCheckOut,
        origenReserva,
        codigoReserva,
        cantidadPersonas,
        tipoHabitacion,
        tipoHabitacionId,
        experiencias,
        reservaIdSaved,
        descuentoId,
        folioSaved,
        experienciasSaved,
        nombreHuespedSaved,
        telefonoHuespedSaved,
        emailHuespedSaved,
        totalSaved,
        pagosSaved,
        comentarioSaved,
        habitacionId,
        tarifasSeleccionadas,
        tarifasAdicionalesSeleccionadas,
    } = getParams(location.state)

    const numNoches = fechaReserva.length === 1 ? 1 : diffDays(fechaReserva[0], fechaReserva[1])

    const todasLasTarifasIds = [
        ...tarifasSeleccionadas.map((t) => t.tarifa_id),
        ...tarifasAdicionalesSeleccionadas.map((t) => t.tarifa_id),
    ].filter(Boolean)
    const tipoAlojamiento = tarifasSeleccionadas[0]?.tipo_alojamiento || TiposAlojamientos.Hotel

    const fechaInicio = fechaReserva[0] ? getStartOfHotelDayISO(fechaReserva[0]) : ""
    const fechaFinal = fechaReserva[1]
        ? getStartOfHotelDayISO(addDays({ date: fechaReserva[1], days: -1 }))
        : fechaReserva[0] ? getStartOfHotelDayISO(fechaReserva[0]) : ""

    const { resumen_tarifas, total_tarifas, desglose_tarifas } = useMotorTarifas({
        tarifas: tarifasSeleccionadas,
        tarifas_adicionales: tarifasAdicionalesSeleccionadas,
        tipo: tipoAlojamiento,
        horas_extra: 0,
        personas_extra: cantidadPersonasExtra,
        hospedajes_extra: 0,
        fecha_inicio: fechaInicio,
        fecha_final: fechaFinal,
    })

    const { data: listaExperiencias } = useGetExperienciasQuery({
        variables: { hotel_id: hotel_id },
    })

    const experienciasSeleccionadas =
        listaExperiencias?.experiencias
            ?.filter((exp) => experiencias.includes(exp.experiencia_id))
            ?.map((exp) => ({
                value: exp.precio,
                label: exp.nombre,
            })) || []

    const experienciasSeleccionadasIds = experiencias.filter((id) => !experienciasSaved.includes(id))

    const costoExperiencias = Number(new Decimal(sum(experienciasSeleccionadas.map((exp) => exp.value))).toDecimalPlaces(2))

    const costoEstancia = desglose_tarifas.reduce((acc, d) => acc + d.subtotal_hospedaje, 0)
    const costoPersonasExtraTotal = desglose_tarifas.reduce((acc, d) => acc + d.subtotal_personas_extra, 0)

    const totalResumen = sum([costoEstancia, costoPersonasExtraTotal, costoExperiencias])
    const totalConDescuento = minus(totalResumen, descuento.total)

    const totalPagosSavedSum = (pagos: any[]) => {
        const totals = pagos.map((pago) => pago.total)
        return sum(totals)
    }
    const totalPagosSaved = pagosSaved ? totalPagosSavedSum(pagosSaved) : 0

    const { opciones_descuentos: opcionesDescuentosDisponibles, loading: loadingDescuentos } = useOpcionesDescuentos({
        type: "reservas",
        tipo_habitacion_ids: tipoHabitacionId ? [tipoHabitacionId] : undefined,
        grupo_descuento: tipoAlojamiento,
        fecha_inicio: fechaInicio,
        fecha_fin: fechaFinal,
        total: totalResumen,
        fin_offset: 2,
    })

    useEffect(() => {
        if (isDescuentoDisabled && descuento.descuento_id) {
            setDescuento({ descuento_id: "", total: 0, nombre: "", visible: false })
        }
    }, [isDescuentoDisabled])

    useEffect(() => {
        if (!reservaIdSaved || reservaIdSaved === "undefined" || !descuentoId || loadingDescuentos) return
        const found = opcionesDescuentosDisponibles.find(o => o.value === descuentoId)
        setDescuento({
            descuento_id: found ? found.value : "",
            total: found ? (found.total || 0) : 0,
            nombre: found ? (found.label?.split(" | ")?.[0] || "") : "",
            visible: false,
        })
    }, [descuentoId, loadingDescuentos])

    useEffect(() => {
        const total_general =
            totalPagosSaved > 0
                ? totalConDescuento - totalPagosSaved
                : totalConDescuento

        setValue("costs", {
            room: costoEstancia,
            users: costoPersonasExtraTotal,
            experiencias: costoExperiencias,
            total: totalConDescuento,
            general: total_general,
            payment: 0,
        })
        if (reservaIdSaved) {
            setValue("name", nombreHuespedSaved)
            setValue("phoneNumber", telefonoHuespedSaved)
            setValue("email", emailHuespedSaved)
            setValue("comment", comentarioSaved)
        }
    }, [tipoPago, methods, costoExperiencias, total_tarifas, descuento.total])

    const onBack = (): void => setIsCancelModalOpen(true)

    const onConfirmSubmit = (values: FormValues) => {
        if (!tryStartLoading()) {
            return
        }
        const user = usuario_id
        const {
            fechaReserva,
            cantidadPersonas,
            cantidadPersonasExtra,
            origenReserva,
            tipoHabitacionId,
            codigoReserva,
            folioSaved,
        } = getParams(location.state)
        let origenR: OrigenRservas = origenReserva
        let crearReservaInput: CreateReservaInput = {
            comentarios: [],
            correo_huesped: null,
            fecha_entrada: "",
            fecha_salida: "",
            hotel_id: "",
            nombre_huesped: "",
            numero_personas: 0,
            origen: OrigenRservas[origenReserva],
            codigo_ota: codigoReserva,
            tarifas_ids: todasLasTarifasIds.length > 0 ? todasLasTarifasIds : [],
            telefono_huesped: null,
            tipo_habitacion_id: "",
            total: 0,
            usuario_id: "",
            experiencias_ids: [],
        }
        let actualizarReservaInput: UpdateReservaInput = {
            reserva_id: reservaIdSaved,
            comentarios: [values.comment],
            correo_huesped: values.email?.length ? values.email : null,
            fecha_entrada: localDateToUTCString(
                setHHMMSS({ startDate: fechaReserva[0], newHour: horaCheckIn })
            ),
            fecha_salida: localDateToUTCString(
                setHHMMSS({ startDate: fechaReserva[1], newHour: horaCheckOut })
            ),
            hotel_id: hotel_id,
            hospedajes_extra: 0,
            nombre_huesped: values.name,
            numero_personas: cantidadPersonas,
            personas_extras: cantidadPersonasExtra,
            origen: origenR,
            codigo_ota: codigoReserva,
            tarifas_ids: todasLasTarifasIds.length > 0 ? todasLasTarifasIds : [],
            telefono_huesped: values.phoneNumber ? quitarParentesisYEspacios(values.phoneNumber) : null,
            tipo_habitacion_id: tipoHabitacionId,
            usuario_id: user,
            experiencias_ids: experienciasSeleccionadasIds,
            servicios_reserva: [],
            total: totalPagosSaved > 0 ? totalPagosSaved : 0,
            habitacion_id: habitacionId || null
        }

        if (Object.prototype.hasOwnProperty.call(OrigenRservas, origenReserva)) {
            origenR = OrigenRservas[origenReserva]
        }
        const totalCostos = costos?.general || 0
        if (reservaIdSaved && totalPagosSaved === totalCostos && totalCostos > 0) {
            values.payment = "pendiente"
        }
        if (values.payment === "pendiente") {
            reservaIdSaved
                ? (actualizarReservaInput = {
                    ...actualizarReservaInput,
                    total: values.costs.general,
                    estado: EstadosReservas.SinAsignar,
                })
                : (crearReservaInput = {
                    comentarios: [values.comment],
                    correo_huesped: values.email?.length ? values.email : null,
                    fecha_entrada: localDateToUTCString(
                        setHHMMSS({ startDate: fechaReserva[0], newHour: horaCheckIn })
                    ),
                    fecha_salida: localDateToUTCString(
                        setHHMMSS({ startDate: fechaReserva[1], newHour: horaCheckOut })
                    ),
                    hotel_id: hotel_id,
                    hospedajes_extra: 0,
                    nombre_huesped: values.name,
                    numero_personas: cantidadPersonas,
                    personas_extras: cantidadPersonasExtra,
                    origen: origenR,
                    codigo_ota: codigoReserva,
                    tarifas_ids: todasLasTarifasIds.length > 0 ? todasLasTarifasIds : [],
                    telefono_huesped: values.phoneNumber ? quitarParentesisYEspacios(values.phoneNumber) : null,
                    tipo_habitacion_id: tipoHabitacionId,
                    total: values.costs.general,
                    usuario_id: user,
                    experiencias_ids: experienciasSeleccionadasIds,
                })
        }
        const easyrewardsId = lovePointsAmount?.id
        const detalleDePago = values.extra.map((extra, index) => {
            const subtotalBase =
                values.payment === "total"
                    ? values.extra.length > 1
                        ? extra.amount
                        : values.costs.general
                    : values.payment === "parcial"
                    ? extra.amount
                    : 0
            const detalle: DetallePagoPartialInfoObject = {
                tipo_pago: extra.type as TiposPagos,
                subtotal: subtotalBase,
                easyrewards_id: easyrewardsId,
            }

            if (extra.type !== "efectivo") {
                detalle.ultimos_digitos = values.transferNumber
            }

            if (extra.number !== "") {
                detalle.ultimos_digitos = extra.number
            }

            return detalle
        })

        if (!values.payment) {
            const hasNewNegativeExperiences = experienciasSeleccionadasIds.some((id) => {
                const exp = (listaExperiencias?.experiencias ?? []).find((e) => e.experiencia_id === id)
                return exp !== undefined && exp.precio < 0
            })
            const useDepositPayment = costoExperiencias < 0 && values.costs.general <= 0
            const depositPayment = {
                total: 0,
                detallesPago: [{
                    tipo_pago: TiposPagos.DepositoOTransferencia,
                    subtotal: 0,
                    numero_referencia: "0"
                }],
                hotel_id: hotel_id,
                usuario_id: user,
            }
            const defaultPayment = useDepositPayment ? depositPayment : null
            const editPayment = hasNewNegativeExperiences ? defaultPayment : null

            reservaIdSaved
                ? (actualizarReservaInput = {
                    ...actualizarReservaInput,
                    pago: editPayment,
                })
                : (crearReservaInput = {
                    comentarios: [values.comment],
                    correo_huesped: values.email?.length ? values.email : null,
                    fecha_entrada: localDateToUTCString(
                        setHHMMSS({ startDate: fechaReserva[0], newHour: horaCheckIn })
                    ),
                    fecha_salida: localDateToUTCString(
                        setHHMMSS({ startDate: fechaReserva[1], newHour: horaCheckOut })
                    ),
                    hotel_id: hotel_id,
                    hospedajes_extra: 0,
                    nombre_huesped: values.name,
                    numero_personas: cantidadPersonas,
                    personas_extras: cantidadPersonasExtra,
                    origen: origenR,
                    codigo_ota: codigoReserva,
                    descuento_id: descuento.descuento_id || null,
                    tarifas_ids: todasLasTarifasIds.length > 0 ? todasLasTarifasIds : [],
                    telefono_huesped: values.phoneNumber ? quitarParentesisYEspacios(values.phoneNumber) : null,
                    tipo_habitacion_id: tipoHabitacionId,
                    total: 0,
                    usuario_id: user,
                    pago: defaultPayment,
                    experiencias_ids: experienciasSeleccionadasIds,
                })
        }

        if (values.payment === "total") {
            reservaIdSaved
                ? (actualizarReservaInput = {
                    ...actualizarReservaInput,
                    pago: {
                        total: sum([...detalleDePago.map((dp) => dp.subtotal)]),
                        detallesPago: detalleDePago,
                        hotel_id: hotel_id,
                        usuario_id: user,
                    },
                })
                : (crearReservaInput = {
                    comentarios: [values.comment],
                    correo_huesped: values.email?.length ? values.email : null,
                    fecha_entrada: localDateToUTCString(
                        setHHMMSS({ startDate: fechaReserva[0], newHour: horaCheckIn })
                    ),
                    fecha_salida: localDateToUTCString(
                        setHHMMSS({ startDate: fechaReserva[1], newHour: horaCheckOut })
                    ),
                    hotel_id: hotel_id,
                    hospedajes_extra: 0,
                    nombre_huesped: values.name,
                    numero_personas: cantidadPersonas,
                    personas_extras: cantidadPersonasExtra,
                    origen: origenR,
                    codigo_ota: codigoReserva,
                    descuento_id: descuento.descuento_id || null,
                    tarifas_ids: todasLasTarifasIds.length > 0 ? todasLasTarifasIds : [],
                    telefono_huesped: values.phoneNumber ? quitarParentesisYEspacios(values.phoneNumber) : null,
                    tipo_habitacion_id: tipoHabitacionId,
                    total: values.costs.general,
                    usuario_id: user,
                    pago: {
                        total: sum([...detalleDePago.map((dp) => dp.subtotal)]),
                        detallesPago: detalleDePago,
                        hotel_id: hotel_id,
                        usuario_id: user,
                    },
                    experiencias_ids: experienciasSeleccionadasIds,
                })
        }
        if (values.payment === "parcial") {
            reservaIdSaved
                ? (actualizarReservaInput = {
                    ...actualizarReservaInput,
                    pago: {
                        total: sum([...detalleDePago.map((dp) => dp.subtotal)]),
                        detallesPago: detalleDePago,
                        hotel_id: hotel_id,
                        usuario_id: user,
                    },
                })
                : (crearReservaInput = {
                    comentarios: [values.comment],
                    correo_huesped: values.email?.length ? values.email : null,
                    fecha_entrada: localDateToUTCString(
                        setHHMMSS({ startDate: fechaReserva[0], newHour: horaCheckIn })
                    ),
                    fecha_salida: localDateToUTCString(
                        setHHMMSS({ startDate: fechaReserva[1], newHour: horaCheckOut })
                    ),
                    hospedajes_extra: 0,
                    hotel_id: hotel_id,
                    nombre_huesped: values.name,
                    numero_personas: cantidadPersonas,
                    personas_extras: cantidadPersonasExtra,
                    origen: origenR,
                    codigo_ota: codigoReserva,
                    descuento_id: descuento.descuento_id || null,
                    tarifas_ids: todasLasTarifasIds.length > 0 ? todasLasTarifasIds : [],
                    telefono_huesped: values.phoneNumber ? quitarParentesisYEspacios(values.phoneNumber) : null,
                    tipo_habitacion_id: tipoHabitacionId,
                    total: values.costs.general,
                    usuario_id: user,
                    pago: {
                        total: sum([...detalleDePago.map((dp) => dp.subtotal)]),
                        detallesPago: detalleDePago,
                        hotel_id: hotel_id,
                        usuario_id: user,
                    },
                    experiencias_ids: experienciasSeleccionadasIds,
                })
        }

        reservaIdSaved
            ? updateReservaMutation({
                variables: { actualizarReservaInput },
            })
                .then((data) => {
                    setCodigoRes(String(codigoReserva || "-"))
                    setReservaFolio(`${folioSaved}`)
                    showMiniSnackbar({
                        title: "Reserva editada",
                        text: `Se actualizó la reserva **${folioSaved}** correctamente.`,
                        status: "success",
                    })
                    navigate("/u/reservaciones/table", { replace: true })
                })
                .catch((e) => {
                    console.log(e)
                    setVisibleToast(true)
                })
                .finally(() => {
                    toggleIsLoading({ value: false })
                })
            : createReservaMutation({
                variables: { crearReservaInput },
            })
                .then(({ data }) => {
                    setCodigoRes(String(codigoReserva || "-"))
                    setReservaFolio(`${data?.crear_reserva?.reserva?.folio || "-"}`)
                    setisModalConfirmOpen(true)
                    if (values.payment !== "pendiente") {
                        window.location.href = `print://${data?.crear_reserva?.ticket?.ticket_id?.[0] || ""}_0/`
                    }
                })
                .catch((e) => {
                    console.log(e)
                    setVisibleToast(true)
                })
                .finally(() => {
                    toggleIsLoading({ value: false })
                })
    }

    useEffect(() => {
        if (visibleToast) {
            setTimeout(() => setVisibleToast(false), 5000)
        }
    }, [visibleToast])

    const getEmailError = (): string => {
        const type = methods.formState.errors.email?.type
        return type === "required" ? "Ingresa un correo" : type === "pattern" ? "Ingresa un correo válido" : ""
    }

    useEscapeKey({
        onEscape: () => {
            navigate(reservaIdSaved ? `/u/registro-reserva/${location.state?.reservaIdSaved}` : `/u/registro-reserva`, {
                state: { ...getParams(location.state) },
            })
        },
    })

    const { isBetween12AMAndCheckInHour } = useValidSameDayRent(horaCheckIn, false, horaCheckOut)

    const [isAuthModalOpen, setisAuthModalOpen] = useState(false)
    const { Modal } = useAuth({
        authModal: (
            <AuthRequiredModal
                isOpen={isAuthModalOpen}
                onAuthFilled={() => {
                    onConfirmSubmit(methods.getValues())
                    setisAuthModalOpen(false)
                }}
                onClose={() => setisAuthModalOpen(false)}
                authorizedRoles={[RoleNames.recepcionista, RoleNames.admin, RoleNames.gerente, RoleNames.superadmin]}
                authorizedPins={[RoleNames.admin, RoleNames.superadmin]}
            />
        ),
        authorizedRoles: [RoleNames.recepcionista, RoleNames.admin, RoleNames.gerente, RoleNames.superadmin],
        isOpen: isAuthModalOpen,
        onClose: () => setisAuthModalOpen(false),
        noNeedAuthModalRoles: [],
    })

    const onSubmit = (values: FormValues) => {
        if (!isBetween12AMAndCheckInHour && fechaReserva.length === 1) {
            setisAuthModalOpen(true)
            return
        }
        onConfirmSubmit(values)
    }

    const showPagos = reservaIdSaved ? costos.general > 0 ? totalPagosSaved !== costos.general : false : costos.general > 0

    return (
        <Screen
            title={reservaIdSaved ? `Edición de reservación ${folioSaved}` : "Registro de reserva"}
            className="guest-screen-container"
            contentClassName="guest-screen"
            onClose={onBack}
            onBack={() => {
                navigate(
                    reservaIdSaved ? `/u/registro-reserva/2/${location.state?.reservaIdSaved}` : `/u/registro-reserva`,
                    { state: { ...getParams(location.state) } }
                )
            }}
            back={true}
            close={true}
        >
            <FormProvider {...methods}>
                <form className="guest-screen__form" onSubmit={handleSubmit(onSubmit)}>
                    <div className="guest-screen__col-left">
                        <div className="guest-screen__block" style={{ marginTop: "20px" }}>
                            <h5 className="guest-screen__subtitle">{"Huésped"}</h5>
                            <div className="guest-screen__row">
                                <Controller
                                    control={control}
                                    name={"name"}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange }, formState: { errors } }) => (
                                        <InputText
                                            className={"guest-screen__input-text"}
                                            label={"Nombre completo"}
                                            type={"text"}
                                            placeholder={"Nombre del huésped"}
                                            value={value}
                                            onChange={(e) => onChange(e.target.value)}
                                            icon={Icon}
                                            iconProps={{
                                                name: "userFilled",
                                                ...inputIconStyle,
                                            }}
                                            loader={loading}
                                            onBlur={() => {
                                                getIncidenciasHuesped({
                                                    variables: {
                                                        hotel_id,
                                                        matricula: null,
                                                        huesped: clientName || null,
                                                    },
                                                })
                                            }}
                                            error={
                                                !!errors?.name || (!!clientName && !!incidenciasHuesped?.incidencias[0])
                                            }
                                            errorhinttext={
                                                errors?.name
                                                    ? "Agrega nombre del huésped"
                                                    : "Huésped con reporte de incidencia. Más detalle en el módulo de incidencias."
                                            }
                                        />
                                    )}
                                />
                                <Controller
                                    control={control}
                                    name={"phoneNumber"}
                                    rules={{ required: false, validate: (v) => /^[^_]*$/.test(v) }}
                                    render={({ field: { value, onChange }, formState: { errors } }) => (
                                        <InputTel
                                            className={"guest-screen__input-text"}
                                            label={"Número de teléfono"}
                                            hinttext="Opcional"
                                            placeholder={"(55) 5555 5555"}
                                            telValue={value}
                                            prefixValue={"MX +52"}
                                            onPrefixChange={(e) => console.log(e.value)}
                                            onInputChange={(e) => onChange(e)}
                                            error={!!errors?.phoneNumber}
                                            errorhinttext={"Agrega número de teléfono"}
                                        />
                                    )}
                                />
                                <Controller
                                    control={control}
                                    name={"email"}
                                    rules={{ required: false, pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i }}
                                    render={({ field: { value, onChange }, formState: { errors } }) => (
                                        <InputText
                                            className={"guest-screen__input-text"}
                                            label={"Correo"}
                                            hinttext="Opcional"
                                            type={"text"}
                                            placeholder={"ejemplo@correo.com"}
                                            value={value}
                                            onChange={(e) => onChange(e.target.value)}
                                            icon={Icon}
                                            iconProps={{
                                                name: "openMailFill",
                                                ...inputIconStyle,
                                            }}
                                            error={!!errors?.email}
                                            errorhinttext={getEmailError()}
                                        />
                                    )}
                                />
                            </div>
                        </div>
                        {showPagos ? (
                            <div className="guest-screen__block">
                                <h5 className="guest-screen__subtitle">{"Pago de reservación"}</h5>
                                <div className="guest-screen__row">
                                    <Controller
                                        control={control}
                                        name={"payment"}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange }, formState: { errors } }) => (
                                            <Dropdown
                                                icon={"dollarCircle"}
                                                iconInOptions={false}
                                                className={"guest-screen__select"}
                                                label={"Pago"}
                                                placeholder={"Selecciona una opción"}
                                                errorHintText={errors.payment ? "Selecciona una opción" : ""}
                                                options={reservaIdSaved ? amountPaymentsEdit : amountPayments}
                                                value={value}
                                                onClick={({ value }) => {
                                                    setValue("payment", value, {
                                                        shouldValidate: true,
                                                        shouldDirty: true,
                                                    })
                                                    setValue("extra", [], { shouldValidate: true, shouldDirty: true })
                                                    setValue("cardNumber", "", {
                                                        shouldValidate: true,
                                                        shouldDirty: true,
                                                    })
                                                    setValue("advance", 0, { shouldValidate: true, shouldDirty: true })
                                                    onChange(value)
                                                }}
                                            />
                                        )}
                                    />
                                    <PaymentSelect control={control} state={stateMixto} onClick={setStateMixto} />
                                    <PaymentFields costoExperiencias={costoExperiencias || 0} />
                                    <AbonarEasyRewardsFields
                                        setLovePointsAmount={setLovePointsAmount}
                                        lovePointsAmount={lovePointsAmount}
                                    />
                                </div>
                            </div>
                        ) : null}
                        <div>
                            <h5 className="guest-screen__subtitle">{"Comentarios"}</h5>
                            <Controller
                                control={control}
                                name={"comment"}
                                render={({ field: { value, onChange } }) => (
                                    <TextBox
                                        className={"guest-screen__textarea"}
                                        placeholder={"Escribe un comentario..."}
                                        value={value}
                                        onChange={(e) => onChange(e.target.value)}
                                    />
                                )}
                            />
                        </div>
                    </div>
                    <Resumen
                        disabled={isLoadingDelayed}
                        aux={{
                            numNoches: numNoches,
                        }}
                        costos={{
                            estancia: costos.room,
                            personasExtra: costos.users,
                            experiencias: costoExperiencias,
                            total: totalConDescuento,
                        }}
                        descuento={{ nombre: descuento.nombre, total: descuento.total }}
                        onOpenDescuento={() => setDescuento({ ...descuento, visible: true })}
                        descuentoEditable={!!reservaIdSaved || !isDescuentoDisabled}
                        descuentoDisabled={isDescuentoDisabled}
                        labels={{
                            clientName,
                            codigo: codigoReserva,
                            origen: origenReserva,
                            fechasEstancia: fechaReserva,
                            personas: cantidadPersonas,
                            personasExtra: cantidadPersonasExtra,
                            tipoHabitacion,
                            correo: methods.watch("email"),
                            telefono: methods.watch("phoneNumber"),
                            experiencias: experienciasSeleccionadas,
                        }}
                        tarifas={resumen_tarifas.hospedaje}
                        tarifasPersonaExtra={resumen_tarifas.personas_extra}
                        lovePointsAmount={lovePointsAmount}
                        onEditMixto={() => setStateMixto({ visible: true, edited: true })}
                        reservaSaved={{
                            reservaIdSaved: reservaIdSaved,
                            folioSaved: folioSaved,
                            pagosTotalSaved: totalPagosSaved,
                            pagosSaved: pagosSaved,
                            totalSaved: totalSaved,
                        }}
                    />
                </form>
                <ModalMixto
                    paymentOptions={[
                        PAYMENT_METHODS.efectivo,
                        PAYMENT_METHODS.visaOMasterCard,
                        PAYMENT_METHODS.amex,
                        PAYMENT_METHODS.depositoOTransferencia,
                    ]}
                    validateTotal={tipoPago !== payments[1].value}
                    visible={stateMixto.visible}
                    edited={stateMixto.edited}
                    onClose={() => setStateMixto({ visible: false, edited: false })}
                />
            </FormProvider>
            <ModalAcceptReservation
                isOpen={isModalConfirmOpen}
                reservationDate={
                    fechaReserva[1]
                        ? `${formatCustomDate(fechaReserva[0], "DD/MMM/YY")} - ${formatCustomDate(fechaReserva[1], "DD/MMM/YY")}`
                        : `${formatCustomDate(fechaReserva[0], "DD/MMM/YY")}`
                }
                OTACode={`#${codigoRes}`}
                folio={reservaFolio}
                onCancel={() => {
                    setisModalConfirmOpen(false)
                    navigate("/u/reservaciones/table", { replace: true })
                }}
            />
            <ModalConfirm
                isOpen={reservaIdSaved ? isErrorUpdateR : isErrorCreateR}
                title={reservaIdSaved ? "Error al editar reserva" : "Error al crear reserva"}
                description={reservaIdSaved ? "Error al editar reserva" : "Se ha creado un error al crear la reserva"}
                icon={<Icon name="Warning" color="var(--pink-ocupado)" />}
                iconTheme="danger"
                onClose={() => (reservaIdSaved ? setIsErrorUpdateR(false) : setIsErrorCreateR(false))}
            />
            <CancelReservaModal
                isOpen={isCancelModalOpen}
                isEditMode={!!reservaIdSaved}
                onClose={() => setIsCancelModalOpen(false)}
            />
            <SnackBar
                title={reservaIdSaved ? "Error al editar una reserva" : "Error al registrar una reserva"}
                isOpen={visibleToast}
                onClose={() => setVisibleToast(false)}
                status={"error"}
            >
                <p>¡Ups! Se ha producido un error. Por favor, inténtalo nuevamente.</p>
            </SnackBar>
            <LoaderComponent visible={isLoading} />
            {Modal}
            {descuento.visible && !reservaIdSaved && (
                <ModalDescuentos
                    filter={{
                        type: "reservas",
                        tipo_habitacion_ids: tipoHabitacionId ? [tipoHabitacionId] : undefined,
                        grupo_descuento: TiposAlojamientos.Hotel,
                        fecha_inicio: fechaInicio,
                        fecha_fin: fechaFinal,
                        total: totalResumen,
                        sin_vigencia: true,
                        fin_offset: 2
                    }}
                    onChange={(v) => {
                        setDescuento({ descuento_id: v.descuento_id, total: v.total, nombre: v.nombre, visible: false })
                        if (methods.getValues("method") === "mixto") {
                            methods.setValue("method", "")
                            methods.setValue("extra", [])
                            methods.setValue("cardNumber", "")
                            methods.setValue("advance", 0)
                            setStateMixto({ visible: false, edited: false })
                        }
                    }}
                    onClose={()=> setDescuento({...descuento, visible: false})}
                    value={{ descuento_id: descuento.descuento_id, total: descuento.total, nombre: descuento.nombre }}
                />
            )}
        </Screen>
    )
}

export default ReservaFormularioFinal
